<template>
  <div v-if="items.length > 0">

  <div class="accordion" id="accordion">
    <div v-for="item in items" :key="item.id" class="accordion-itemX border-0 mb-1 rounded bg-white">
      <div class="accordion-header">
        <div
          class="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          :data-bs-target="'#collapse-' + item.id"
          aria-expanded="true"
          :aria-controls="'collapse-' + item.id">
          <div>
            <strong class="mb-1">{{ item.externalname }}</strong>
            <div class="d-flex gap-3">
              <small><i class="far fa-calendar"></i> {{ formatDate(item.timestamp) }}</small>
              <small v-if="item.address"><i class="far fa-house"></i> {{ item.address }}</small>
            </div>
          </div>
        </div>
      </div>
      <div :id="'collapse-' + item.id" class="accordion-collapse collapse" style="background: #F9F9F7;" data-bs-parent="#accordion">
        <div class="accordion-body">
          <div v-for="note in item.notes" :key="note.id" class="shadow-sm p-3 mb-3 bg-white">
            <small>{{ note.date }} </small><br />
            {{ note.text }}
          </div>
 
        <div v-if="item.checklist.length === 0">Har du några frågor eller behöver hjälp angående ditt ärende är du välkommen att höra av dig till oss.</div>

          <div class="timeline-steps">
            <ul class="list-unstyled m-0">
              <li
                v-for="checklist in item.checklist"
                :key="checklist.id"
                class="step"
                :class="checklist.checkliststatus">
                <div class="icon d-flex align-items-center">
                  <div class="inside icon-0 d-flex justify-content-center align-items-center">
                    <div v-if="checklist.checkliststatus === 'current'">
                      <i class="fa-regular fa-arrow-right"></i>
                    </div>
                    <div v-else>
                      <i
                        :class="{
                          'fa-regular fa-check': checklist.done,
                          'fa-regular fa-xmark': checklist.ignore,
                        }"></i>
                    </div>
                  </div>
                </div>

                <div class="text">
                 
                  <strong class="d-block checklistHeader mb-2">{{ checklist.externheading }}</strong>
                  <div v-if="!checklist.ignore">
                    {{ checklist.externdescription }}<br />
                    <small v-if="checklist.done">{{ checklist.time }} </small>
                  </div>
                  <div v-else>Detta steg är inte aktuellt för ditt ärende</div>
                </div>
              </li>
       
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div v-else class="p-3 d-flex gap-3 bg-white align-items-center rounded">
  <svg width="42px" style="fill: #47525d" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M32 208V384c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112S32 146.1 32 208zm256 0V384c0 11.7-3.1 22.6-8.6 32H512c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112H234.5c32.6 26.4 53.5 66.8 53.5 112zM64 448c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64H432c79.5 0 144 64.5 144 144V384c0 35.3-28.7 64-64 64H224 64zm48-256h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0h96 56c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H440c-13.3 0-24-10.7-24-24V224H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96h32V224H448v64z"/></svg>     
  <strong>Inga ärenden att visa.</strong>
</div>
</template>
<script>
const formatDate = (timestamp) => timestamp.slice(0, 10).replace("T", " ");

export default {
  props: ["items"],
 

  methods: {
    formatDate,
    isTimePassed(checklistTime) {
      if (checklistTime !== null) {
        const currentDate = new Date();
        const parsedChecklistTime = new Date(checklistTime);

        return currentDate > parsedChecklistTime;
      }
      return false;
    }
  }

};

</script>
